import React from 'react';
import {withFirebase} from "../Firebase/context";

const AuthUserContext = React.createContext(null);

// The AuthUserContext.Provider will be handled by the app component
// We'll just handle auth here, because we need it on a per-route basis
export const withSession = Component => {
    class WithSession extends React.Component {
        constructor(props) {
            super(props);
            this.state = {authenticated: false}
        }

        componentDidMount() {
            this.listener = this.props.firebase.auth.onAuthStateChanged(
                authUser => {
                    if(!authUser) {
                        this.props.firebase.signIn();
                    } else {
                        this.setState({authenticated: true})
                    }
                }
            );
        }
        componentWillUnmount() {
            this.listener();
        }
        render() {
            return this.state.authenticated && (
                <AuthUserContext.Consumer>
                    {auth => <Component {...this.props} auth={auth} />}
                </AuthUserContext.Consumer>
            )
        }
    }
    return withFirebase(WithSession);
};

export const withAdmin = Component => {
    class WithAdmin extends React.Component {
        constructor(props) {
            super(props);
            this.state = {authenticated: false, loaded: false}
        }
        componentDidMount() {
            this.listener = this.props.firebase.auth.onAuthStateChanged(
                authUser => {
                    if(!authUser) {
                        this.login();
                    } else {
                        this.setState({loaded:true});
                        this.props.firebase.me().get().then(doc => {
                            if(doc && doc.data().admin) {
                                this.setState({authenticated:true});
                            }
                        }).catch(err => { })
                    }
                }
            );
        }
        componentWillUnmount() {
            this.listener();
        }
        login = () => {
            this.props.firebase.signInWithGoogle();
        };
        render() {
            return this.state.authenticated ? (
                <AuthUserContext.Consumer>
                    {auth => <Component {...this.props} auth={auth} />}
                </AuthUserContext.Consumer>
            ) : this.state.loaded ? (<p>Your user is not authorized, <a href="javascript:void(0)" onClick={this.login}>login with Google</a></p>) : null
        }
    }
    return withFirebase(WithAdmin);
};

export default AuthUserContext;